import { GET_CLIENT_ORDERS, GET_ORDERS } from "../actions/actionTypes"


const initialState = {
  orders: [],
  clientOrders: []
}

export default function(state=initialState, action){
  switch (action.type) {
   
    case GET_ORDERS:
      return{
        ...state,
        orders: action.payload
      }

    case GET_CLIENT_ORDERS:
      return {
        ...state,
        clientOrders: action.payload
      }
  
    default:
      return state
  }
}